import { /* useEffect, */ useState } from 'react'
/* import { getUserCountry } from 'lib/firebase' */
import { useOuCookies } from './useOuCookies'

export const useInitializeCookies = () => {
  const { cookies, setCustomCookie, consentNecessary, consentAnalytical, consentMarketing } = useOuCookies()

  const [cookieCountry, setCookieCountryState] = useState<string | null>(cookies['country'] || null)
  const [cookieLocale, setCookieLocaleState] = useState<string | null>(cookies['NEXT_LOCALE'] || null)

  /* useEffect(() => {
    const init = async () => {
      if (!cookieCountry) {
        const defaultCountry = await getUserCountry()
        const finalCountry = defaultCountry ?? 'GB'
        setCustomCookie('country', finalCountry)
        setCookieCountryState(finalCountry)
      }

      if (!cookieLocale) {
        const defaultLocale = 'en-gb'
        setCustomCookie('NEXT_LOCALE', defaultLocale)
        setCookieLocaleState(defaultLocale)
      }
    }

    if (typeof window !== 'undefined') {
      init()
    }
  }, []) */

  const setCookieCountry = (value: string) => {
    if (!value || value === 'undefined') return
    setCustomCookie('country', value)
    setCookieCountryState(value)
  }

  const setCookieLocale = (value: string) => {
    if (!value || value === 'undefined') return
    setCustomCookie('NEXT_LOCALE', value)
    setCookieLocaleState(value)
  }

  return {
    cookieCountry,
    setCookieCountry,
    cookieLocale,
    setCookieLocale,
    consentNecessary,
    consentAnalytical,
    consentMarketing,
    cookies,
    setCustomCookie,
  }
}
